(function () {
    'use strict';

    angular.module('swif.ui')
        .config(route);

    function route($routeProvider) {
        'ngInject';

        $routeProvider.when('/logout', {
            templateUrl: 'partials/ui/logout.html',
            controller: LogoutController,
            resolve: {
                data: ['swifRouteService', 'swifOAuthService', function (route, oauth) {
                    return route.check({public: true})
                    .then(function () {
                        return oauth.singleSignOut();
                    });
                }]
            }
        });
    }

    function LogoutController(swif, $location, swifOAuthService, data) {
        'ngInject';
        console.log('LogoutController');
        //if user comes from ozwillo oauth

        swif.user.logout();
        var next = {};
        if ($location.search().next) {
            next.next = $location.search().next;
        }
        $location.search(next);
        swif.collection.collections = {}; //remove all collections;
        swif.message.addInfo('Logout successfully');
        swif.message.clearErrors();
        if (data.oauth_logout_endpoint) {
            var url = data.oauth_logout_endpoint,
                params = { id_token_hint: data.id_token_hint,
                           post_logout_redirect_uri:  data.post_logout_redirect_uri }

            url = swifOAuthService.formatUrl(url, params)

            window.location.replace(url);
        }
    }

})();
